import http from '@/utils/http'
import Vue from 'vue'
/*
 * @Author: zly
 * @Date: 2021-07-20 13:45:37
 * @LastEditTime: 2022-06-30 17:07:05
 * @LastEditors: 汪俊洪
 * @Description:文件流生成
 * @Params haveMsg 后台是否会返回错误提示
 */
const exportFun = ({
  url = '',
  params = {},
  name = '',
  type = 'application/json',
  haveMsg = false,
  method = 'post'
}) => {
  if (method === 'get') {
    params = { params: params, responseType: 'blob' }
  }
  return new Promise((resolve) => {
    http[method](url, params, {
      responseType: 'blob'
    }).then((res) => {
      // 判断是不是下载类型
      const isAttachment =
        res.headers['content-disposition'] &&
        res.headers['content-disposition'].indexOf('attachment') === 0
      if (haveMsg) {
        if (res.data.size > 0) {
          // const that = this
          const reader = new FileReader()
          reader.onload = (e) => {
            if (e.target.result.indexOf('"code":') === -1 || isAttachment) {
              download(res, type, name)
              resolve(true)
            } else {
              const data = JSON.parse(e.target.result)
              if (data.code !== 0) {
                Vue.prototype.$message.error(data.message || '下载失败')
              }
              resolve(false)
            }
          }
          reader.readAsText(res.data)
        }
      } else {
        download(res, type, name)
        resolve(true)
      }
    })
  })
}

function download (res, type, name) {
  let backEndFileName = '' // 后端返回的表格名称
  if (res.headers['content-disposition']) {
    backEndFileName = decodeURI(res.headers['content-disposition'])
    backEndFileName = backEndFileName.split('=')[1]
  }
  const blob = new Blob([res.data], { type: type || res.data.type })
  // const fileName = name // xlsx
  const fileName = backEndFileName || name // 先取后端命名 后端命名存在关键字不过滤情况
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}

export default exportFun
